import React from 'react';
import { howItWorksData } from '../data/mockData';
import { ArrowRight } from 'lucide-react';

const HowItWorks = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#8bcaf9]/20 text-[#1297fd] rounded-full text-sm font-medium mb-4">
            Cómo funciona
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Tres simples pasos para{' '}
            <span className="text-[#40aaf8]">el éxito</span>
          </h2>
          <p className="text-lg text-[#c3c3c5] max-w-2xl mx-auto">
            Descubre cómo nuestras soluciones innovadoras han ayudado a empresas a mejorar su seguridad y escalar con confianza.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 rounded-full transform -translate-y-1/2" style={{ background: 'linear-gradient(to right, #4E95D9, #2B6FA8)' }} />

          <div className="grid md:grid-cols-3 gap-8 relative">
            {howItWorksData.map((item, idx) => (
              <div key={item.step} className="relative">
                <div className="bg-white rounded-3xl p-8 border-2 border-[#e3e4e6] hover:border-[#8bcaf9] transition-all duration-500 hover:shadow-2xl hover:shadow-[#1297fd]/10 hover:-translate-y-2 group">
                  {/* Step Number */}
                  <div className="relative z-10 w-20 h-20 mx-auto mb-6">
                    <div className="absolute inset-0 bg-[#8bcaf9] rounded-2xl transform rotate-6 group-hover:rotate-12 transition-transform" />
                    <div className="relative w-full h-full rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                      <span className="text-3xl font-bold text-white">{item.step}</span>
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center group-hover:text-[#1297fd] transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-[#c3c3c5] text-center leading-relaxed">
                    {item.description}
                  </p>

                  {/* Arrow (except last) */}
                  {idx < howItWorksData.length - 1 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                      <div className="w-8 h-8 bg-[#1297fd] rounded-full flex items-center justify-center shadow-lg">
                        <ArrowRight className="w-4 h-4 text-white" />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
